import { render, staticRenderFns } from "./ContactInitiated.vue?vue&type=template&id=3c418571&scoped=true&"
import script from "./ContactInitiated.vue?vue&type=script&lang=js&"
export * from "./ContactInitiated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c418571",
  null
  
)

export default component.exports